export const DEFAULT_ACTION_TIMEOUT_MS = 18 * 1000;
export const DEFAULT_ASSERTION_TIMEOUT_MS = 10 * 1000;
export const DEFAULT_NAVIGATION_TIMEOUT_MS = 30 * 1000; // Playwright default
export const MIN_TIMEOUT_MS = 1 * 1000;
export const MAX_TIMEOUT_MS = 300 * 1000;
